import {
	SaveNote,
	DeleteNote,
	GetAllNotes,
	CreateNote,
	AddToMeeting
} from '../../connection/notes';
import { Note } from '../types/notes';
import { Action, AsyncAction } from '../types/types';

function isNum(n: any): boolean {
	return !isNaN(Number(n))
}

export const GET_NOTES = "GET_NOTES";
export function getNotes(token: string): AsyncAction {
	return {
		type: GET_NOTES,
		promise: GetAllNotes(token)
	}
}

export const SAVE_NOTE = "SAVE_NOTE";
export function saveNote(token: string, note: Note): AsyncAction {
	return {
		type: SAVE_NOTE,
		promise: SaveNote(token, note.meeting, note.title, note.content, note.content_text, note.shared_with, isNum(note.id) ? Number(note.id) : undefined)
	}
}

export const DELETE_NOTE = "DELETE_NOTE";
export function deleteNote(token: string, note: number): AsyncAction {
	return {
		type: DELETE_NOTE,
		promise: DeleteNote(token, note)
	}
}

export const REMOVE_NOTE = "REMOVE_NOTE";
export function removeNote(note: number | string): Action {
	return {
		type: REMOVE_NOTE,
		payload: note
	}
}


export const CREATE_NOTE = "CREATE_NOTE";
export function createNote(token: string, meeting: number, fromGlobal?: boolean): AsyncAction {
	return {
		type: CREATE_NOTE,
		promise: CreateNote(token, meeting, fromGlobal)
	}
}

export const SET_WORKING_NOTE = "SET_WORKING_NOTE";
export function setWorkingNote(note: Note | null): Action {
	return {
		type: SET_WORKING_NOTE,
		payload: note
	}
}

export const SET_WORKING_ALL_NOTE = "SET_WORKING_ALL_NOTE";
export function setWorkingAllNote(note: Note | null): Action {
	return {
		type: SET_WORKING_ALL_NOTE,
		payload: note
	}
}

export const SET_SHOW_WORKING_NOTE = "SET_SHOW_WORKING_NOTE";
export function setShowWorkingNote(yes: boolean) {
	return {
		type: SET_SHOW_WORKING_NOTE,
		payload: yes
	}
}

export const SET_SHOW_WORKING_ALL_NOTE = "SET_SHOW_WORKING_ALL_NOTE";
export function setShowWorkingAllNote(yes: boolean) {
	return {
		type: SET_SHOW_WORKING_ALL_NOTE,
		payload: yes
	}
}

export const SET_SHARED_WITH = "SET_SHARED_WITH";
export function setSharedWith(shared_with: string | null) {
	return {
		type: SET_SHARED_WITH,
		payload: shared_with
	}
}

export const SET_SHARED_WITH_GLOBAL = "SET_SHARED_WITH_GLOBAL";
export function setSharedWithGlobal(shared_with: string | null) {
	return {
		type: SET_SHARED_WITH_GLOBAL,
		payload: shared_with
	}
}

export const SET_NOTES_DRAWER_OPEN = "SET_NOTES_DRAWER_OPEN";
export function setNotesDrawerOpen(open: boolean) {
	return {
		type: SET_NOTES_DRAWER_OPEN,
		payload: open
	}
}

export const ADD_NOTE_TO_MEETING = "ADD_NOTE_TO_MEETING";
export function addNoteToMeeting(token: string, meeting: number, id: number) {
	return {
		type: ADD_NOTE_TO_MEETING,
		promise: AddToMeeting(token, meeting, id)
	}
}